(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  function makeQuery(keyword, tags) {
    var clauses = tags.map(function (tag) { return 'tag:"' + tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"'; });
    if (keyword.trim()) clauses.unshift(tags.length ? '(' + keyword.trim() + ')' : keyword.trim());
    return clauses.join(' AND ') || '*';
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-archive-search]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var form = root.querySelector('[data-search-form]');
      var keyword = form.querySelector('[data-search-keyword]');
      var selects = Array.from(form.querySelectorAll('[data-search-tag]'));
      var params = new URLSearchParams(window.location.search);
      var savedKeyword = params.get('archive_keyword') || '';
      var savedTags = selects.map(function (select) { return params.get('archive_' + select.dataset.searchTag) || ''; });
      if (params.get('archive') === '1' && makeQuery(savedKeyword, savedTags.filter(Boolean)) === keyword.value) {
        keyword.value = savedKeyword;
        selects.forEach(function (select, index) {
          var value = savedTags[index];
          if (!value || !value.startsWith(select.dataset.searchTag + ': ')) return;
          if (!Array.from(select.options).some(function (option) { return option.value === value; })) {
            select.add(new Option(value.slice(select.dataset.searchTag.length + 2), value));
          }
          select.disabled = false;
          select.value = value;
        });
      } else if (keyword.value === '*') keyword.value = '';
      var clear = root.querySelector('[data-search-clear]');
      function updateClear() {
        var url = new URL(form.action);
        if (keyword.value.trim()) { url.searchParams.set('type', 'product'); url.searchParams.set('q', keyword.value.trim()); }
        clear.href = url.toString();
      }
      updateClear();
      keyword.addEventListener('input', updateClear);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var url = new URL(form.action);
        var next = new URLSearchParams(new FormData(form));
        Array.from(next.entries()).forEach(function (pair) { if (!pair[1]) next.delete(pair[0]); });
        var tags = selects.map(function (select) { return select.value; }).filter(Boolean);
        next.set('q', makeQuery(keyword.value, tags));
        next.set('archive', '1');
        next.set('archive_keyword', keyword.value.trim());
        selects.forEach(function (select) { if (select.value) next.set('archive_' + select.dataset.searchTag, select.value); });
        ['preview_theme_id', 'pb'].forEach(function (name) { if (params.has(name)) next.set(name, params.get(name)); });
        url.search = next.toString();
        window.location.assign(url.toString());
      });
      form.querySelector('[data-search-sort]').addEventListener('change', function () { form.requestSubmit(); });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
